var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.obj),function(text){return _c('li',{key:text,staticClass:"redtickl"},[_vm._v(_vm._s(text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }